'use client'

import { Card, Divider, InputText, InputTextArea, Label } from '@vinted/web-ui'
import { useFormContext } from 'react-hook-form'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import RequiredValidation from '../RequiredValidation'
import { ProIntegrationsApplicationFormField } from '../constants'
import { ProIntegrationsApplicationFormModel } from '../types'

const BusinessDetails = () => {
  const translate = useTranslate('business.pro_integrations_application.form.business_details')
  const {
    register,
    formState: { errors },
  } = useFormContext<ProIntegrationsApplicationFormModel>()

  return (
    <Card>
      <SeparatedList separator={<Divider />}>
        <>
          <Label styling={Label.Styling.Wide} type={Label.Type.Leading} text={translate('title')} />
          <InputText
            {...register(ProIntegrationsApplicationFormField.ShopUrl, { required: true })}
            styling={InputText.Styling.Wide}
            title={translate('shop_url.title')}
            placeholder={translate('shop_url.placeholder')}
            validation={
              <RequiredValidation
                error={errors[ProIntegrationsApplicationFormField.ShopUrl]}
                testId="pro-integrations-application-form-shop-url-validation"
              />
            }
            testId="pro-integrations-application-form-shop-url"
          />
        </>
        <InputTextArea
          {...register(ProIntegrationsApplicationFormField.ItemTypes, { required: true })}
          styling={InputText.Styling.Wide}
          title={translate('item_types.title')}
          placeholder={translate('item_types.placeholder')}
          validation={
            <RequiredValidation
              error={errors[ProIntegrationsApplicationFormField.ItemTypes]}
              testId="pro-integrations-application-form-item-types-validation"
            />
          }
          rows={3}
          uncontrolled
          testId="pro-integrations-application-form-item-types"
        />
        <InputText
          {...register(ProIntegrationsApplicationFormField.ItemAmount, { required: true })}
          styling={InputText.Styling.Wide}
          title={translate('item_amount.title')}
          placeholder={translate('item_amount.placeholder')}
          validation={
            <RequiredValidation
              error={errors[ProIntegrationsApplicationFormField.ItemAmount]}
              testId="pro-integrations-application-form-item-amount-validation"
            />
          }
          testId="pro-integrations-application-form-item-amount"
        />
        <InputText
          {...register(ProIntegrationsApplicationFormField.ItemValue, { required: true })}
          styling={InputText.Styling.Wide}
          title={translate('item_value.title')}
          placeholder={translate('item_value.placeholder')}
          validation={
            <RequiredValidation
              error={errors[ProIntegrationsApplicationFormField.ItemValue]}
              testId="pro-integrations-application-form-item-value-validation"
            />
          }
          testId="pro-integrations-application-form-item-value"
        />
        <InputText
          {...register(ProIntegrationsApplicationFormField.MonthlyListings, { required: true })}
          styling={InputText.Styling.Wide}
          title={translate('monthly_listings.title')}
          placeholder={translate('monthly_listings.placeholder')}
          validation={
            <RequiredValidation
              error={errors[ProIntegrationsApplicationFormField.MonthlyListings]}
              testId="pro-integrations-application-form-monthly-listings-validation"
            />
          }
          testId="pro-integrations-application-form-monthly-listings"
        />
      </SeparatedList>
    </Card>
  )
}

export default BusinessDetails
